import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Typography, Box, TextField, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import axios from 'axios';
import Cookies from 'js-cookie'

import CreateCouponDialog from './new_coupon';
import DeleteCouponTrimestreDialog from './delete_couponTrimestre';
import DeleteCouponWooDialog from './delete_couponWoo';
// Définit les trimestres
const Trimestres = ['Trimestre-1', 'Trimestre-2', 'Trimestre-3', 'Trimestre-4'];

export default function Coupons() {

  const [selectedTrimestre, setSelectedTrimestre] = useState('T1');

  const [coupons, setCoupons] = useState([]);  // Stocke les coupons du trimestre actif
  const [couponsWoo, setCouponsWoo] = useState([]);  // Stocke les coupons du trimestre actif
  const [newCoupon, setNewCoupon] = useState({ clubNumber: '', amount: '', description: '' });
  const [errorAxios, setErrorAxios] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [reload, setReload] = useState(0);
  const [openDialogNew, setOpenDialogNew] = useState(false);
  const [openDialogDeleteTrimestre, setOpenDialogDeleteTrimestre] = useState(false);
  const [openDialogDeleteWoo, setOpenDialogDeleteWoo] = useState(false);
  const [couponToDelete, setCouponToDelete] = useState({ deleteId: '', coupon_code: '' });


  const MyAxios = axios.create({
    headers: {
      Authorization: "Bearer " + Cookies.get('token'),
    }
  })



  const handleOpenNewDialog = () => {
    setOpenDialogNew(true);
  };


  const handleOpenDeleteTrimestreDialog = (couponCode) => {
    const wooCoupon = couponsWoo.find((woo) => woo.code.toLowerCase() == couponCode.toLowerCase());
    if (wooCoupon)
      setCouponToDelete({ deleteId: wooCoupon.id, coupon_code: couponCode });
    else
      setCouponToDelete({ deleteId: null, coupon_code: couponCode });
    //console.log({ deleteId: wooCoupon.id, coupon_code: couponCode });
    setOpenDialogDeleteTrimestre(true);

  };
  const handleOpenDeleteWooDialog = (couponCode) => {
    const wooCoupon = couponsWoo.find((woo) => woo.code.toLowerCase() == couponCode.toLowerCase());
    //console.log( {deleteId:wooCoupon.id ,coupon_code:couponCode});
    setCouponToDelete({ deleteId: wooCoupon.id, coupon_code: couponCode });
    setOpenDialogDeleteWoo(true);

  };

  const handleCloseNewDialog = () => {
    setOpenDialogNew(false);
    setReload(prevCount => prevCount + 1);
  };


  const handleCloseDeleteTrimestreDialog = () => {
    setOpenDialogDeleteTrimestre(false);
    setReload(prevCount => prevCount + 1);
  };


  const handleCloseDeleteWooDialog = () => {
    setOpenDialogDeleteWoo(false);
    setReload(prevCount => prevCount + 1);
  };


  // Charger les coupons de la base MySQL pour le trimestre actif

  useEffect(() => {
   // console.log(activeTab);
    const fetchCoupons = async () => {
      try {


        const [responseCoupons, responseWoo] = await Promise.all([
          MyAxios.get(process.env.REACT_APP_API + '/coupons/get/' + activeTab),
          MyAxios.get(process.env.REACT_APP_API + '/woo/listAllCoupons/')
        ]);

        setErrorAxios(false);

        const couponsData = responseCoupons.data;
        const wooCouponsData = responseWoo.data;
        setCouponsWoo(wooCouponsData);
        //console.log(couponsData);
        //console.log(wooCouponsData);

        // Ajouter les valeurs des coupons WooCommerce aux coupons locaux
        const updatedCoupons = couponsData.map((coupon) => {
          //console.log(coupon);
          // Trouver le coupon WooCommerce correspondant (par exemple, avec l'ID ou le nom)
          const wooCoupon = wooCouponsData.find((woo) => woo.code.toLowerCase() == coupon.coupon_code.toLowerCase()); // Assumes both have a 'code' field in common
          //console.log(wooCoupon);
          // Si un coupon WooCommerce correspondant est trouvé, ajouter la valeur du rabais
          if (wooCoupon) {
          //  console.log("trouver...");
            return {
              ...coupon, // Conserve les propriétés originales du coupon
              wooDiscount: wooCoupon.amount, // Ajoute le rabais du WooCommerce au coupon
              discount_type: wooCoupon.discount_type
            };
          }

          // Si aucun coupon WooCommerce n'est trouvé, retourne le coupon original
          return coupon;
        });

        setCoupons(updatedCoupons); // Met à jour l'état avec les coupons enrichis

       // console.log(updatedCoupons);
      }
      catch (error) {
        console.error('Une erreur s\'est produite lors de la récupération des données', error);
      }
    }
    fetchCoupons();
  }, []);

  useEffect(() => {
   // console.log(activeTab);
    const fetchCoupons = async () => {
      try {


        const [responseCoupons, responseWoo] = await Promise.all([
          MyAxios.get(process.env.REACT_APP_API + '/coupons/get/' + activeTab),
          MyAxios.get(process.env.REACT_APP_API + '/woo/listAllCoupons/')
        ]);

        setErrorAxios(false);

        const couponsData = responseCoupons.data;
        const wooCouponsData = responseWoo.data;
       // console.log(couponsData);
       // console.log(wooCouponsData);
        setCouponsWoo(wooCouponsData);
        // Ajouter les valeurs des coupons WooCommerce aux coupons locaux
        const updatedCoupons = couponsData.map((coupon) => {
          //console.log(coupon);
          // Trouver le coupon WooCommerce correspondant (par exemple, avec l'ID ou le nom)
          const wooCoupon = wooCouponsData.find((woo) => woo.code.toLowerCase() == coupon.coupon_code.toLowerCase()); // Assumes both have a 'code' field in common
         // console.log(wooCoupon);
          // Si un coupon WooCommerce correspondant est trouvé, ajouter la valeur du rabais
          if (wooCoupon) {
           // console.log("trouver...");
            return {
              ...coupon, // Conserve les propriétés originales du coupon
              wooDiscount: wooCoupon.amount, // Ajoute le rabais du WooCommerce au coupon
              discount_type: wooCoupon.discount_type
            };
          }

          // Si aucun coupon WooCommerce n'est trouvé, retourne le coupon original
          return coupon;
        });

        setCoupons(updatedCoupons); // Met à jour l'état avec les coupons enrichis

       // console.log(updatedCoupons);
      }
      catch (error) {
        console.error('Une erreur s\'est produite lors de la récupération des données', error);
      }
    }
    fetchCoupons();
  }, [activeTab, reload]);

  // Gérer le changement d'onglet (trimestre)
  const handleTabChange = function (event, newIndex) {
    setActiveTab(newIndex);
  };

  // Gérer les changements dans le formulaire d'ajout de coupon
  const handleInputChange = function (event) {
    const { name, value } = event.target;
    setNewCoupon(Object.assign({}, newCoupon, { [name]: value }));
  };



  // Supprimer un coupon
  const handleDeleteCouponTrimestre = async function (id) {

    //setOpenDialogDelete(true);
    // setCouponToDelete(id);
  };



  // Supprimer un coupon
  const handleDeleteCouponWoo = async function (id) {
    try {
      await axios.delete(process.env.REACT_APP_API + '/coupons/delete/' + id);
      setCoupons(coupons.filter(function (coupon) {
        return coupon.id !== id;
      }));
    } catch (error) {
      console.error('Erreur lors de la suppression du coupon', error);
    }
  };

  // Interface React avec createElement
  return (<>
    <Grid container spacing={2} sx={{ padding: 2 }}>
      {/* Panneau de gauche pour gestion des coupons WooCommerce */}
      <Grid item xs={4}>
        <Paper sx={{ padding: 2, maxHeight: '80vh', overflowY: 'auto' }}>
          <Typography variant="h6" gutterBottom>
            Gestion des Coupons WooCommerce
          </Typography>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Nom du Coupon</TableCell>
                <TableCell>Date d'expiration</TableCell>
                <TableCell>Type de rabais</TableCell>
                <TableCell>Montant</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {couponsWoo.map((coupons) => (
                <TableRow key={coupons.id}>
                  <TableCell>{coupons.code}</TableCell>
                  <TableCell>{coupons.date_expires || 'N/A'}</TableCell>
                  <TableCell>{coupons.discount_type == "fixed_cart" ? 'Remise fixe' : "Pourcentage"}</TableCell>
                  <TableCell>{coupons.amount}</TableCell>
                  <TableCell>
                    <Button color="secondary" onClick={() => handleOpenDeleteWooDialog(coupons.code)}>
                      Supprimer
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Grid>

      {/* Panneau de droite pour la facturation par trimestre */}


      <Grid item xs={8}>

        <Paper sx={{ padding: 2 }}>

          <Button onClick={handleOpenNewDialog} color="primary" variant="containedFifth">
            Créer un nouveau coupon
          </Button>

          {/* Onglets pour les trimestres */}
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Trimestre 1" />
            <Tab label="Trimestre 2" />
            <Tab label="Trimestre 3" />
            <Tab label="Trimestre 4" />
          </Tabs>

          {/* Contenu pour chaque trimestre */}
          <Box sx={{ padding: 2 }}>
            {activeTab === 0 && (
              <Typography variant="h6" gutterBottom>
                Coupons et rabais du Trimestre 1
              </Typography>
            )}
            {activeTab === 1 && (
              <Typography variant="h6" gutterBottom>
                Coupons et rabais du Trimestre 2
              </Typography>
            )}
            {activeTab === 2 && (
              <Typography variant="h6" gutterBottom>
                Coupons et rabais du Trimestre 3
              </Typography>
            )}
            {activeTab === 3 && (
              <Typography variant="h6" gutterBottom>
                Coupons et rabais du Trimestre 4
              </Typography>
            )}


            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Club ID</TableCell>
                  <TableCell>Coupon</TableCell>
                  <TableCell>Type de rabais</TableCell>
                  <TableCell>Montant du rabais</TableCell>
                  <TableCell>Raison</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {coupons.map((coupon) => (
                  <TableRow key={coupon.id}>
                    <TableCell>{coupon.fk_club_master}</TableCell>
                    <TableCell>{coupon.coupon_code}</TableCell>
                    <TableCell>{coupon.discount_type == "fixed_cart" ? 'Remise fixe' : "Pourcentage"}</TableCell>
                    <TableCell>{coupon.wooDiscount}</TableCell>
                    <TableCell>{coupon.raison}</TableCell>
                    <TableCell>
                      <Button color="secondary" onClick={() => handleOpenDeleteTrimestreDialog(coupon.coupon_code)}>
                        Supprimer
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </Box>
        </Paper>
      </Grid>
    </Grid>

    <CreateCouponDialog
      open={openDialogNew}
      handleClose={handleCloseNewDialog}
    />


    <DeleteCouponTrimestreDialog
      open={openDialogDeleteTrimestre}
      couponToDelete={couponToDelete}
      handleClose={handleCloseDeleteTrimestreDialog}
    />


    <DeleteCouponWooDialog
      open={openDialogDeleteWoo}
      couponToDelete={couponToDelete}
      handleClose={handleCloseDeleteWooDialog}
    />

  </>

  )
}
